<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  created() {
    console.log(this.$cookies.get('user'))
    if (localStorage.myCarts) {
      const carts = JSON.parse(localStorage.myCarts)
      this.$store.commit('cart/SET_STATE', { carts })
    } else {
      localStorage.setItem('myCarts', '[]')
    }
    if (this.$cookies.isKey('sessionId')) {
      const sessionId = this.$cookies.get('sessionId')
      this.$store.commit('user/SET_STATE', { sessionId })
    }
  },
  computed: {
  },
}
</script>
<style lang="scss">
// #app {
//   font-family: Avenir, Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: #2c3e50;
// }
// @font-face {
//   font-family: "Nunito Sans";
//   src: local("Nunito Sans"),
//    url(./assets/font/NunitoSans-Regular.ttf) format("truetype");
// }

// @font-face {
//   font-family: "Open Sans";
//   src: local("Open Sans"),
//    url(./assets/font/OpenSans-Regular.ttf) format("truetype");
// }
</style>
